import store from "../store"
import React from 'react'
import Dashed from '../components/typography/Dashed.js'

function is_logged_on() {
  const { auth } = store.getState()
  const { current_user } = auth
  return ( auth.isAuthenticated && (current_user.data !== undefined || current_user.data !== null || Object.keys(current_user.data).length > 0) ) || false
}

function is_validating() {
  const { auth } = store.getState()
  return auth.isValidating
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.replace(/_/g, " ").slice(1);
}

function is_numeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

function extract_errors(errors, key) {
  if (!(errors instanceof Array) && errors[key] ) {
    return capitalize(key) + " " + errors[key][0]
  }
  return false
}

function trim_to_length(inputstring, inputlength) {
  if (inputstring.length < inputlength) {
    return inputstring
  }
  let bd = inputstring.split(/\s/)
  let l = 0
  let i = 0
  let fieldstring = ''
  while ( l < inputlength ) {
    fieldstring = fieldstring + ' ' + bd[i]
    l = fieldstring.length
    i++
  }
  if ( fieldstring.length < inputstring.length ) {
    fieldstring = fieldstring + '...'
  }
  return fieldstring
}

function renderBody(body, length) {
  if (body === undefined || body === null) {
    return ""
  }
  const fieldstring = (length !== undefined) ? trim_to_length(body, length) : body
  let dashes = []
  let body_parts = fieldstring.toString().replace(/\[+([^\]]*)\]+/g, function(match, $1) {
    dashes.push($1); return "^%%%^"
  }).split("^").filter( a => a!== "")
  if ( dashes.length === 0 ) {
    return fieldstring
  } else {
    return (
      <React.Fragment>
      {
        body_parts.map( (body_part, index) => {
          if (body_part === "%%%") {
            return <Dashed key={index} text={dashes.shift()} />
          } else {
            return <React.Fragment key={index}>{body_part}</React.Fragment>
          }
        })
      }
      </React.Fragment>
    )
  }
}

function current_timestamp() {
  return  window.performance && window.performance.now && window.performance.timing && window.performance.timing.navigationStart ? window.performance.now() + window.performance.timing.navigationStart : Date.now();
}

function format_number(n, decimals=true) {
  let int_part = parseInt(n, 10)
  const dec_part = (n - int_part).toFixed(2)

  if (decimals) {
    if ( !(dec_part < 1) ) {
      int_part = int_part + 1
    }
    const numberWithDecimalSeparator = 1.1;
    const separator = numberWithDecimalSeparator.toLocaleString().substring(1, 2);
    return `${int_part.toLocaleString()}${separator}${dec_part.replace(/^../,'')}`
  } else {
    if ( dec_part >= 0.5 ) {
      int_part = int_part + 1
    }
    return int_part.toLocaleString()
  }
}

export {
  is_logged_on,
  is_validating,
  extract_errors,
  trim_to_length,
  renderBody,
  capitalize,
  is_numeric,
  current_timestamp,
  format_number
}

// export * from './dashes'
export * from './form_components'
export * from './mui'



// WEBPACK FOOTER //
// ./src/js/helpers/index.js